import { RouteName } from '@mews-commander/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { openModal } from './common';

export const openTravelAgencyContractDetail =
    (id: string): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const url = resolveRoute(RouteName.TravelAgencyContractDetail, { id });
        return dispatch(openModal(url));
    };
